export default __webpack_public_path__ + "static/media/douglas-crockford.0ccf3220.png";